import { useConfigContext } from "@/state/configContext";
import { fotoFecha, fotoURL } from "@/helpers/foto";
import { useEffect, useRef, useState, useCallback, type JSX } from "react";
import { faLeftLong, faRightLong } from "@fortawesome/free-solid-svg-icons";
import { Fa } from "@/helpers/Fa";
import type { Foto } from "@/state/types";

type Props = {
  Icons: (props: {
    fotos: Foto[];
    foto: Foto;
    setActive: () => unknown;
  }) => JSX.Element;
  fotos: Foto[];
  selected: number;
  onSelected: (idx: number) => unknown;
  onClose: () => unknown;
};

export function Big({
  Icons,
  selected,
  fotos,
  onSelected,
  //icons: Icons,
  //buscadorActions,
  onClose,
}: Props) {
  const config = useConfigContext();

  const [w, setW] = useState(100);
  const [h, setH] = useState(100);
  const [imgh, setImgh] = useState(100);

  const fotoRef = useRef<HTMLImageElement>(null);
  const imgRef = useRef<HTMLImageElement>(null);

  const f = fotos[selected];

  const recalcDims = useCallback(() => {
    const dom_f = fotoRef.current;
    const dom_img = imgRef.current;

    if (!dom_f || !dom_img) return;

    let iw = dom_img.naturalWidth || 1;
    let ih = dom_img.naturalHeight || 1;

    const tw = dom_f.offsetWidth;
    const th = window.innerHeight - dom_f.getBoundingClientRect().top - 160;

    let newImgh;
    if ((ih * tw) / iw <= th) {
      newImgh = (ih * tw) / iw;
    } else {
      newImgh = th - 10;
    }

    setW(tw);
    setH(th);
    setImgh(newImgh);
  }, []);

  const handleKeyDown = useCallback(
    (e: { keyCode: number }) => {
      if (e.keyCode === 37) {
        prev();
      } else if (e.keyCode === 39) {
        next();
      } else if (e.keyCode === 27) {
        onClose();
      }
    },
    [onClose]
  );

  const prev = () => {
    if (selected > 0) onSelected(selected - 1);
  };

  const next = () => {
    const p = selected + 1;
    if (p < fotos.length) onSelected(p);
  };

  useEffect(() => {
    if (fotos.length === 0) onClose();
  }, [fotos, onClose]);

  useEffect(() => {
    window.addEventListener("resize", recalcDims);
    document.body.addEventListener("keydown", handleKeyDown);

    recalcDims();

    return () => {
      window.removeEventListener("resize", recalcDims);
      document.body.removeEventListener("keydown", handleKeyDown);
    };
  }, [recalcDims, handleKeyDown]);

  if (!f) return <div>No hay fotos</div>;

  return (
    <div>
      <div className="row" style={{ textAlign: "center", marginRight: 0 }}>
        <div className="col-md-12">
          <button className="close" onClick={onClose}>
            &times;
          </button>
          <h4>
            <a href={`#/buscador?foto_id=${f.i}`}>{f.i}</a>{" "}
            | {fotoFecha(f)} ({config.fotografos[f.g].codigo})
          </h4>
        </div>
      </div>
      <div
        className="row"
        style={{
          textAlign: "center",
          position: "relative",
          height: h,
          marginRight: 0,
        }}
      >
        <div className="col-md-12 fotobig" ref={fotoRef}>
          <img
            key={f.i}
            src={fotoURL(f, "big")}
            ref={imgRef}
            onLoad={recalcDims}
            height={imgh}
          />
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: w / 2,
              height: h,
            }}
            onClick={prev}
          />
          <div
            style={{
              position: "absolute",
              top: 0,
              left: w / 2,
              width: w / 2,
              height: h,
            }}
            onClick={next}
          />
        </div>
      </div>
      <div className="pager">
        <div className="col-md-4" style={{ textAlign: "left" }}>
          {selected > 0 && (
            <button onClick={prev}>
              <Fa icon={faLeftLong} />
              &nbsp;
              <img src={fotoURL(fotos[selected - 1], "small")} />
            </button>
          )}
        </div>
        <div className="col-md-4" style={{ textAlign: "center" }}>
          <Icons fotos={fotos} foto={f} setActive={() => 0} />
        </div>
        <div className="col-md-4" style={{ textAlign: "right" }}>
          {selected < fotos.length - 1 && (
            <button onClick={next}>
              <img src={fotoURL(fotos[selected + 1], "small")} />
              &nbsp;
              <Fa icon={faRightLong} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
